import I18nUtil from '@didi/i18n-util'
const { getLocale, getLanguage, getRegion } = I18nUtil

export { getLocale, getLanguage, getRegion }
